import React, { useEffect, useState } from "react";
import config from "../config";
import "../styles/Customers.css";

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${config.baseUrl}/api/admin/customers`)
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch customers");
        return response.json();
      })
      .then((data) => {
        setCustomers(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error loading customers");
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="loading">Loading customers...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="customers-container">
      <div className="customers-header">
        <h2>Customer Management</h2>
        <p>Manage customer details and profiles</p>
      </div>

      {customers.length === 0 ? (
        <p className="loading">No customers found.</p>
      ) : (
        <table className="customers-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Role</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((cust) => (
              <tr key={cust.id}>
                <td>{cust.id}</td>
                <td>{cust.name || "N/A"}</td>
                <td>{cust.email}</td>
                <td>{cust.telephoneNumber || "N/A"}</td>
                <td>{cust.role}</td>
                <td className={cust.active ? "status-active" : "status-inactive"}>
                  {cust.active ? "Active" : "Inactive"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
